import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { createUseStyles } from 'react-jss';
import { ThemeContext } from 'styled-components';

import { Card } from '@comparethemarketau/manor-card';

// component
import { GetInTouch } from '../common/get_in_touch';
import { ProceedWithProvider } from '../common/proceed_with_provider';
import { ViewProductDetails } from '../common/view_product_details';
import { withQuoteFlatten } from '../common/with_quote_flatten';
import { Separator } from '../common/separator';

// widget
import { ProductSummaryXs } from '../widget/product_summary_xs';
import { ProductAdditionalXs } from '../widget/product_additional_xs';
import { ProductPriceCardXs } from '../widget/product_price_card_xs';
import { ProductIncludedXs } from '../widget/product_included_xs';

const useStyles = createUseStyles((theme) => ({
    container: {
        marginBottom: theme.spacing[24],
        border: 'unset'
    },
    indexContainer: {
        fontSize: theme.fontSize.xs,
        lineHeight: theme.lineHeight.relaxed,
        fontWeight: theme.fontWeight.bold,
        color: theme.colors.grey600
    },
    cardContainer: {
        display: 'flex',
        flexDirection: 'column',
        padding: {
            top: theme.spacing[12],
            right: theme.spacing[12],
            bottom: '1.4rem',
            left: theme.spacing[12]
        }
    },
    productPriceCard: {
        marginBottom: theme.spacing[12]
    },
    viewProductDetails: {
        paddingTop: '1rem',
        paddingBottom: '1rem',
        marginTop: theme.spacing[8],
        marginBottom: theme.spacing[8]
    },
    separatorBox: {
        marginTop: '0',
        marginBottom: '0'
    }
}));

const _ProductCardXs = (props) => {
    const theme = useContext(ThemeContext);
    const classes = useStyles({ theme });
    const { quote, index, productSpecialConditions } = props;

    return (
        <div className={classNames('test-policyProductCard-xs', classes.container)}>
            <Card
                className={classNames(classes.cardContainer)}
                margin={['0', '0', '0', '0']}
                padding={['0']}
                boxShadow
            >
                <ProductSummaryXs quote={quote} />
                <ProductPriceCardXs quote={quote} />
                <ProductAdditionalXs quote={quote} />
                {productSpecialConditions !== undefined
                    ? <ProductIncludedXs quote={quote} />
                    : <Separator type="horizontal" className={classes.separatorBox} />}
                <ViewProductDetails quote={quote} className={classes.viewProductDetails} />
                <GetInTouch quote={quote} />
                <ProceedWithProvider quote={quote} currentIndex={index} />
            </Card>
        </div>
    );
};

_ProductCardXs.propTypes = {
    quote: PropTypes.object,
    index: PropTypes.number,
    productSpecialConditions: PropTypes.string
};

const ProductCardXs = withQuoteFlatten(_ProductCardXs);

export { ProductCardXs };
